import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { estActivo } from "../../Categorias y Estados/estActivo";
import { Personal } from "../../Personal/Personal";

const columns = () =>
(
    {
        c_ruta_id: new EntityColumn<string>({ name: 'c_ruta_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Ruta ID' }),
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal' }),
        vc_nombre_ruta: new EntityColumn<string>({ name: 'vc_nombre_ruta', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Nombre' }),
        vc_observaciones_ruta: new EntityColumn<string>({ name: 'vc_observaciones_ruta', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciones' }),
        c_activo_id: new EntityColumn<string>({ name: 'c_activo_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        ...DefaultColumns()
    }
)

const lookups = () => ({
    'Personal': {
        name: 'Personal',
        viewMapping: { keyIndex: 0, descriptionIndex: 1 },
        entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
    },
    'Activo': {
        name: 'Activo',
        viewMapping: { keyIndex: 0, descriptionIndex: 1 },
        entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estActivo (client, parentKeys)
    },
})

const views = () =>
(
    {
        ruta_brwStandard: { name: 'ruta_brwStandard', keyMappings: { c_personal_id: 0 } }
    }
)

const procs = () =>
(
    {
        ruta_qryExportar: { name: 'ruta_qryExportar' },
        ruta_qryClientesExportar: { name: 'ruta_qryClientesExportar' },
    }
)

export class RutasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();

    constructor() {
        super('Rutas');
    }
}